import { Component, OnInit, ElementRef, Input, ViewChild, HostListener } from '@angular/core'
import { BeneficiarySoaEmailDetail } from '../models/soa-view-email-model'
import { SOAFormReturnAgentGateWay } from '../gateways/soa-form-return-agent-gateways'
import { Router } from '@angular/router'
import { ActivatedRoute, Params } from '@angular/router'
import { CurrentUser } from '../../common/models/current-user'
import { UserAccessGateway } from '../../common/gateways/user-access-gateway'
import { Location } from '@angular/common'
import { ValidatedCheckboxComponent } from '../../validations/validated-checkbox.component'
import { PortalGlobals } from '../../portalglobals'
import * as moment from 'moment'
@Component({
    selector: 'viewsoaemailform',
    templateUrl: 'soa-view-email.component.html',
    styleUrls: ['soa-form-submission.component.scss']
})
export class SOAViewEmailComponent implements OnInit {
    repRelationShip: any[]
    @Input() beneficiarySoaViewEmailDetail: BeneficiarySoaEmailDetail

    // validation fields begin
    isFormValid: boolean
    isallValid: boolean = true
    PartDChecked: string
    PartCChecked: string
    BeneficiarySignature: string
    BeneficiaryRelationShipError: string
    accesscode: string
    BeneficiarySignatureSpecialCharacter: string
    public currentUser: CurrentUser = {} as CurrentUser
    public loading: boolean = false
    uniqueLink: string
    @ViewChild('focusableEleTop') focusableEleTop: ElementRef
    @ViewChild('focusableEleMid') focusableEleMid: ElementRef
    currentYear: boolean = false
    nextYear: boolean = false
    OtherCheckedValue: boolean = false
    PartCCheckedValue: boolean = false
    PartDCheckedValue: boolean = false
    insuranceCompany: string
    insuranceCompanyShortName: string

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _networkUserAccessGateway: UserAccessGateway,
        private soaFormReturnAgentGateWay: SOAFormReturnAgentGateWay,
        private location: Location,
        private _portalglobal: PortalGlobals
    ) {
        this.repRelationShip = [
            {
                text: '',
                value: ''
            },
            {
                text: 'Aunt',
                value: 'Aunt'
            },
            {
                text: 'Brother',
                value: 'Brother'
            },
            {
                text: 'Caretaker',
                value: 'Caretaker'
            },
            {
                text: 'Case Worker',
                value: 'Case Worker'
            },
            {
                text: 'Companion',
                value: 'Companion'
            },

            {
                text: 'Cousin',
                value: 'Cousin'
            },
            {
                text: 'Daughter',
                value: 'Daughter'
            },
            {
                text: 'Daughter In Law',
                value: 'Daughter In Law'
            },
            {
                text: 'Father',
                value: 'Father'
            },
            {
                text: 'Father In Law',
                value: 'Father In Law'
            },
            {
                text: 'Friend',
                value: 'Friend'
            },
            {
                text: 'Daugther',
                value: 'Daugther'
            },
            {
                text: 'Grand Son',
                value: 'Grand Son'
            },
            {
                text: 'Home Provider',
                value: 'Home Provider'
            },
            {
                text: 'Hospice',
                value: 'Hospice'
            },
            {
                text: 'Husband',
                value: 'Husband'
            },
            {
                text: 'Mother In Law',
                value: 'Mother In Law'
            },
            {
                text: 'Mother',
                value: 'Mother'
            },
            {
                text: 'Nephew',
                value: 'Nephew'
            },
            {
                text: 'Niece',
                value: 'Niece'
            },
            {
                text: 'Power of Attorney',
                value: 'Power of Attorney'
            },

            {
                text: 'Program Coordinator',
                value: 'Program Coordinator'
            },

            {
                text: 'Other',
                value: 'Other'
            },
            {
                text: 'Residential Support',
                value: 'Residential Support'
            },
            {
                text: 'Son In Law',
                value: 'Son In Law'
            },
            {
                text: 'Sister',
                value: 'Sister'
            },

            {
                text: 'Son',
                value: 'Son'
            },
            {
                text: 'Social Worker',
                value: 'Social Worker'
            },
            {
                text: 'Step Daughter',
                value: 'Step Daughter'
            },
            {
                text: 'Step Son',
                value: 'Step Son'
            },
            {
                text: 'Wife',
                value: 'Wife'
            },
            {
                text: 'Spouse',
                value: 'Spouse'
            }
        ]
    }

    @HostListener('window:beforeunload', ['$event']) onbeforeunload(event) {
        // do something here
        console.log('method called')
        this.getParams()
        window.location.assign(window.location.origin + '/ep-ui/#/electronic-soa/soaformagentsigned/' + this.uniqueLink)
    }

    getParams() {
        this.route.params.subscribe((params) => {
            this.uniqueLink = params['accessCode']
        })
    }

    ngOnInit() {
        this.beneficiarySoaViewEmailDetail = {} as BeneficiarySoaEmailDetail

        // read access code from url( email ink)
        this.route.params.subscribe((params) => {
            this.accesscode = params['accessCode']
            console.log('accesscode from url' + this.accesscode)
            this.soaFormReturnAgentGateWay.GetSOADetailsOnUniqueLink(this.accesscode).subscribe((model: BeneficiarySoaEmailDetail) => {
                console.log('unique link test in typescript' + model.FormCompleted)

                // Since we don't have any script changes for plan year 2020, Commenting the below plan year check.
                // For 2020 plan year 2019 scrpit will show
                // If any script will change then will update the below code as per plan year.

                this.nextYear = true
                //if (model.PlanYear == this._portalglobal.AEPPlanYearValue) {
                //    this.currentYear = true;
                //}
                //else if (model.PlanYear == this._portalglobal.AEPPlanYearValue){
                //    this.nextYear = true;
                //}

                if (model.FormCompleted == true) this.router.navigateByUrl('/electronic-soa/soaformagentsigned')

                var appDate = moment(model.ApplicationDate)

                console.log('Difference is ', appDate.diff(new Date(), 'days'))
                let noOfDays = -14
                if (appDate.diff(new Date(), 'days') < noOfDays) this.router.navigateByUrl('/electronic-soa/soaformagentexpired')

                this.beneficiarySoaViewEmailDetail = model

                this.beneficiarySoaViewEmailDetail.BeneficiarySigDate = this.getdate()
                this.beneficiarySoaViewEmailDetail.ApplicationDate = moment(model.ApplicationDate).format('MM/DD/YYYY').toString()
                /* if (this.beneficiarySoaViewEmailDetail.BeneficiaryPhone !== undefined &&
                         this.beneficiarySoaViewEmailDetail.BeneficiaryPhone !== null) {
                         this.beneficiarySoaViewEmailDetail.BeneficiaryPhone = this.beneficiarySoaViewEmailDetail.BeneficiaryPhone.slice(0, 3) + '-' +
                             this.beneficiarySoaViewEmailDetail.BeneficiaryPhone.slice(3, 6) + '-' +
                             this.beneficiarySoaViewEmailDetail.BeneficiaryPhone.slice(6, 10)
                     }*/
                console.log('ben phone view email' + this.beneficiarySoaViewEmailDetail.BeneficiaryPhone)
                this.beneficiarySoaViewEmailDetail.UserProfileID = this.beneficiarySoaViewEmailDetail.UserProfileID
                this.beneficiarySoaViewEmailDetail.RecCreateUserID = this.beneficiarySoaViewEmailDetail.RecCreateUserID
                this.beneficiarySoaViewEmailDetail.LastUpdateUserID = this.beneficiarySoaViewEmailDetail.LastUpdateUserID
                this.beneficiarySoaViewEmailDetail.AgentUserProfileName = this.beneficiarySoaViewEmailDetail.AgentUserProfileName

                console.log('Pulled data from db: ' + this.beneficiarySoaViewEmailDetail)

                if (this.beneficiarySoaViewEmailDetail.PlanYear !== undefined && this.beneficiarySoaViewEmailDetail.PlanYear !== '') {
                    if (this.beneficiarySoaViewEmailDetail.PlanYear === '2020') {
                        this.insuranceCompany = 'SilverScript Insurance Company'
                        this.insuranceCompanyShortName = 'SilverScript'
                    } else {
                        this.insuranceCompany = 'Aetna Insurance Company'
                        this.insuranceCompanyShortName = 'Aetna'
                    }
                }
            })
        })
    }

    returnToAgent(beneficiarySoaViewEmailDetail: BeneficiarySoaEmailDetail): void {
        this.loading = true
        console.log('beneficiarySoaViewEmailDetail from ui' + beneficiarySoaViewEmailDetail)
        beneficiarySoaViewEmailDetail.accessCode = this.accesscode
        this.BeneficiaryRelationShipError = ''
        if (!this.validateForm()) {
            this.isFormValid = false
            this.loading = false
            return
        } else {
            this.isFormValid = true
            this.beneficiarySoaViewEmailDetail.FormCompleted = true
            console.log('bensig' + beneficiarySoaViewEmailDetail.BeneficiarySignatureName)
            console.log('reprel' + beneficiarySoaViewEmailDetail.RepRelationship)
            this.soaFormReturnAgentGateWay.returnToAgent(beneficiarySoaViewEmailDetail).subscribe(
                (model: boolean) => {
                    console.log('BACKENDCALL')
                    this.loading = false
                    this.router.navigateByUrl('/electronic-soa/soaviewagentconf')
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    validateForm(): boolean {
        if (!this.currentYear) {
            this.beneficiarySoaViewEmailDetail.PartCChecked = ''
            this.beneficiarySoaViewEmailDetail.PartDChecked = ''
            this.beneficiarySoaViewEmailDetail.OtherPlanChecked = ''
        }
        if (this.PartCCheckedValue) this.beneficiarySoaViewEmailDetail.PartCChecked = '1'
        //else
        //    this.beneficiarySoaViewEmailDetail.PartCChecked = "NO"
        if (this.PartDCheckedValue) this.beneficiarySoaViewEmailDetail.PartDChecked = '1'
        //else
        //    this.beneficiarySoaViewEmailDetail.PartCChecked = "NO"
        if (this.OtherCheckedValue) this.beneficiarySoaViewEmailDetail.OtherPlanChecked = '1'
        //else
        //    this.beneficiarySoaViewEmailDetail.OtherPlanChecked = "NO"
        if (
            this.beneficiarySoaViewEmailDetail.BeneficiarySignatureName === undefined ||
            this.beneficiarySoaViewEmailDetail.BeneficiarySignatureName === '' ||
            this.beneficiarySoaViewEmailDetail.BeneficiarySignatureName === null
        ) {
            this.isallValid = false
            this.BeneficiarySignature = 'Please fill out the Signature.'
            this.BeneficiarySignatureSpecialCharacter = "Please don't enter any special characters or numbers."
            this.focusableEleMid.nativeElement.focus()
        } else {
            if (/^[a-zA-Z\s]*$/.test(this.beneficiarySoaViewEmailDetail.BeneficiarySignatureName)) {
                this.BeneficiarySignature = ''
                this.BeneficiarySignatureSpecialCharacter = ''
                this.isallValid = true
            } else {
                this.BeneficiarySignature = ''
                this.BeneficiarySignatureSpecialCharacter = "Please don't enter any special characters or numbers."
                this.isallValid = false
                this.focusableEleMid.nativeElement.focus()
            }
        }
        if (this.currentYear) {
            if (
                (this.beneficiarySoaViewEmailDetail.PartDChecked === undefined ||
                    this.beneficiarySoaViewEmailDetail.PartDChecked === '' ||
                    this.beneficiarySoaViewEmailDetail.PartDChecked === null) &&
                (this.beneficiarySoaViewEmailDetail.PartCChecked === undefined ||
                    this.beneficiarySoaViewEmailDetail.PartCChecked === '' ||
                    this.beneficiarySoaViewEmailDetail.PartCChecked === null)
            ) {
                this.isallValid = false
                this.PartDChecked = 'Please fill out the PartD or PartC'
                this.focusableEleTop.nativeElement.focus()
            }
        } else {
            if (
                (this.beneficiarySoaViewEmailDetail.PartDChecked === undefined ||
                    this.beneficiarySoaViewEmailDetail.PartDChecked === '' ||
                    this.beneficiarySoaViewEmailDetail.PartDChecked === null) &&
                (this.beneficiarySoaViewEmailDetail.PartCChecked === undefined ||
                    this.beneficiarySoaViewEmailDetail.PartCChecked === '' ||
                    this.beneficiarySoaViewEmailDetail.PartCChecked === null) &&
                (this.beneficiarySoaViewEmailDetail.OtherPlanChecked === undefined ||
                    this.beneficiarySoaViewEmailDetail.OtherPlanChecked === '' ||
                    this.beneficiarySoaViewEmailDetail.OtherPlanChecked === null)
            ) {
                this.isallValid = false
                this.PartDChecked = 'Please Check atleast one of PartD or PartC or Other Plan'
                this.focusableEleTop.nativeElement.focus()
            }
        }

        this.ValidateAutherizedRepresentative()

        // else {
        //    this.PartDChecked = ''
        //}

        //if (this.beneficiarySoaViewEmailDetail.PartCChecked === undefined
        //    || this.beneficiarySoaViewEmailDetail.PartCChecked === ''
        //    || this.beneficiarySoaViewEmailDetail.PartCChecked === null) {
        //    isallValid = false
        //    this.PartCChecked = 'Please fill out the PartCChecked'

        //} else {
        //    this.PartCChecked = ''
        //}

        return this.isallValid
    }

    getdate(): string {
        let today = new Date()
        let dt = moment(today)
        let date = dt.format('MM/DD/YYYY').toString()
        return date
    }

    ValidateAutherizedRepresentative(): void {
        if (
            this.beneficiarySoaViewEmailDetail.RepName !== undefined &&
            this.beneficiarySoaViewEmailDetail.RepName !== '' &&
            this.beneficiarySoaViewEmailDetail.RepName !== null
        ) {
            if (
                this.beneficiarySoaViewEmailDetail.RepRelationship === undefined ||
                this.beneficiarySoaViewEmailDetail.RepRelationship === '' ||
                this.beneficiarySoaViewEmailDetail.RepRelationship === null
            ) {
                this.isallValid = false
                this.BeneficiaryRelationShipError = 'Please select relationship'
            }
        } else {
            this.BeneficiaryRelationShipError = ''
        }
    }
}
